<div class="tooltip-borders mb-0 ms-0 me-0 border shadow-lg">
	<div class="tooltip-header p-2 text-white fw-semibold fs-6 bg-primary">
		Última coleta:
		{{ markerData.data | date: 'dd/MM/yyyy' }}
	</div>
	<div
		class="tooltip-footer px-3 py-1 text-tertiary font-size-15 bg-white"
		style="white-space: nowrap">
		<div class="d-flex col align-items-center">
			<i class="ph ph-drop fs-1 mt-1"></i>
			<div class="d-flex col py-2" style="margin-left: 5px">
				<span class="fw-semibold" style="margin-right: 5px">Reservatório:</span>
				{{ nomeReservatorio }}
			</div>
		</div>
		<div class="d-flex col align-items-center">
			<i class="ph ph-waves fs-1 mt-1"></i>
			<div class="d-flex col py-2" style="margin-left: 5px">
				<span class="fw-semibold" style="margin-right: 5px">Tipo:</span>
				<ng-container [ngSwitch]="tipoReservatorio">
					<ng-container *ngSwitchCase="'RIO'">Rio</ng-container>
					<ng-container *ngSwitchCase="'ACUDE'">Açude</ng-container>
					<ng-container *ngSwitchDefault>Não especificado</ng-container>
				</ng-container>
			</div>
		</div>
		<div class="d-flex col align-items-center">
			<i class="ph ph-compass fs-1 mt-1"></i>
			<div class="d-flex col py-2" style="margin-left: 5px">
				{{ markerData.latitude | formatDecimal: 4 }}
			</div>
			<i class="ph ph-compass fs-1 mt-1"></i>
			<div class="d-flex col py-2" style="margin-left: 5px">
				{{ markerData.longitude | formatDecimal: 4 }}
			</div>
		</div>
	</div>
</div>
